// Vendor Receiving domain types
// These are local FE types matching the Figma designs.
// They will be replaced with generated GraphQL types once the backend schema is final.

export enum VendorReceivingStatus {
  Pending = 'PENDING',
  CheckedIn = 'CHECKED_IN',
  Allocating = 'ALLOCATING',
  Allocated = 'ALLOCATED',
  Shortage = 'SHORTAGE',
}

export type VendorSummary = {
  vendorId: string;
  vendorName: string;
  orderCount: number;
  totalOrderedQty: number;
  status: VendorReceivingStatus;
  shortageCount: number;
  // null if check-in hasn't started yet, ISO8601DateTime otherwise. Past
  // value = window closed → downstream pages render in view-only mode.
  windowClosesAt: string | null;
};

export type CheckinGroup = {
  deliveryDate: string;
  items: CheckinLineItem[];
};

export type CheckinRowState = {
  receivedQty: number | null;
  vendorPriceTotalCents: number | null;
};

export type AllocationRowState = {
  allocatedQty: number | null;
};

export type CheckinLineItem = {
  itemId: string;
  itemName: string;
  orderedQty: number;
  customerNames: string[];
  markupPercentage: number | null;
  receivedQty: number | null;
  vendorPriceTotalCents: number | null;
  vendorPricePerUnitCents: number | null;
  sellingPricePerUnitCents: number | null;
  windowClosesAt: string | null;
  vendorCode: string | null;
};

export type AllocationLineItem = {
  orderLineId: string;
  itemId: string;
  itemName: string;
  orderedQty: number;
  // Last-saved value from a previous saveVendorAllocation, if any. Used to
  // pre-populate the allocation row instead of falling back to orderedQty
  // — relevant when re-opening a vendor that was already allocated (e.g.
  // ALLOCATED/SHORTAGE status).
  savedFulfillmentQuantity: number | null;
};

export type RouteStopAssignment = {
  routeNumber: string | null;
  stopNumber: string | null;
};

export type CustomerAllocation = {
  customerId: string;
  customerName: string;
  locationName: string;
  routeStopAssignment: RouteStopAssignment;
  orderId: string;
  items: AllocationLineItem[];
};

export enum AllocationStatus {
  Valid = 'Valid',
  Invalid = 'Invalid',
  Shortage = 'Shortage',
}

export enum VendorReceivingStep {
  VendorList = 'vendor-list',
  POCheckIn = 'po-checkin',
  CustomerAllocation = 'customer-allocation',
}
